import { render, staticRenderFns } from "./SubmissionReviewItemSlide.vue?vue&type=template&id=5504e162&scoped=true&"
import script from "./SubmissionReviewItemSlide.vue?vue&type=script&lang=js&"
export * from "./SubmissionReviewItemSlide.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionReviewItemSlide.vue?vue&type=style&index=0&id=5504e162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5504e162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
